import { isAxiosError } from 'axios';
import { axiosAuth } from '@/axios';
import { Endpoints } from '@/enums';

export interface TerminosAceptadosWebRequest {
  userName: string;
  password: string;
}

export const terminosAceptadosWeb = async (
  data: TerminosAceptadosWebRequest
) => {
  try {
    const res = await axiosAuth.post(Endpoints.TerminosAceptadosWeb, data);
    return res.data;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
